module.exports = __webpack_public_path__ + "img/2.ff8d702b.png";